<template>
	<div>
		<div style="margin-bottom:10px; text-align:right;">
			<button class="button" @click="createClicked(null)">Create</button>
		</div>
		<b-modal :active.sync="createCodeModal" has-modal-card trap-focus aria-role="dialog" aria-modal>
			<form @submit.prevent="submit" enctype="multipart/form-data" ref="form">
                <div class="modal-card" style="min-width: 500px">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{ selectedRow ? 'Update' : 'Create' }}</p>
                    </header>
                    <section class="modal-card-body">

                    	<div v-if="selectedRow && logo_path" style="text-align:center;">
                    		<img :src="logo_path" style="max-width:200px;">
                    	</div>

						<b-field>
							<b-upload v-model="form.logo" accept="image/*">
								<b-button icon-left="upload" tag="a">
									<span>{{ form.logo ? form.logo.name : "Choose File" }}</span>
								</b-button>
							</b-upload>
						</b-field>                        
                        <b-field label="Sub Domain">
                            <b-input type="text" v-model="form.subdomain" required></b-input>
                        </b-field>
                        <b-field label="Long Name">
                            <b-input type="text" v-model="form.long_name" required></b-input>
                        </b-field>
                        <b-field label="Short Name">
                            <b-input type="text" v-model="form.short_name" required></b-input>
                        </b-field>
                        <b-field label="Color">
                            <b-input type="text" v-model="form.color" required></b-input>
                        </b-field>
                        <b-field label="Black or White">
                            <b-input type="text" v-model="form.b_or_w" required></b-input>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="createCodeModal = false">Close</button>
                        <button class="button is-primary">Save</button>
                    </footer>
                </div>
            </form>
		</b-modal>
		<base-table
	      :service="$options.portalService"
	      fetch-func="all"
	      :fetch-params="params"
	      :columns="columns"
	      default-sort-direction="desc"
	      :narrowed="false"
	      ref="baseTable"
	    >
			<!-- <template #rowCreator="{ row }">
				<p v-if="row.createdBy">
					{{ row.createdBy.fullName }}
				</p>
			</template> -->
			<template #rowAction="{ row }">
				<b-button @click="createClicked(row)">Edit</b-button>
				<b-button type="is-warning" @click="toggleArchived(row)" v-if="!row.archived_at">Archive</b-button>
				<b-button type="is-dark" @click="toggleArchived(row)" v-else>Restore</b-button>
			</template>
	    </base-table>
	</div>
</template>
<script>
import BaseTable from "@/components/partials/BaseTable";
import { PortalService } from "@/services/portal.service";
export default {
 	portalService: PortalService,
 	components: { BaseTable },
    data: () => ({
    	createCodeModal: false,
    	selectedRow: null,
    	logo_path: null,
    	form: {
    		subdomain: '',
    		long_name: '',
    		short_name: '',
    		color: '',
    		b_or_w: '',
    		logo: null
    	},
    	params: {
    		includes: 'createdBy',
    		orderBy: 'subdomain',
    		sortBy: 'asc'
    	},
    	columns: [
    		// { field: "id", label: "ID" },
    		{ field: "subdomain", label: "Subdomain" },
    		{ field: "long_name", label: "long_name" },
    		{ field: "short_name", label: "short_name" },
    		{ field: "color", label: "color" },
    		{ field: "b_or_w", label: "b_or_w" },
    		// { field: "logo_path", label: "logo_path" },
    		// { label: "Creator", meta: {
	     //        rowSlot: "rowCreator"
	     //    }}
    		{ label: "Action", meta: {
	            rowSlot: "rowAction"
	        }}
    	]
    }),
	methods: {
		fetch() {
			return this.$refs.baseTable.fetchData();
		},
		createClicked(row = null) {
			this.selectedRow = row;
			this.createCodeModal = true;
			this.generateFormData();
		},
		submit() {
			if (this.selectedRow) {
				// Update
				PortalService.update(this.selectedRow.id, this.transformedData()).then(response => {
					this.fetch();
					this.$buefy.toast.open({
						message: "Portal Updated",
						type: "is-success",
						position: "is-top-right"
			        });
			        this.createCodeModal = false;
				})
			}else {
				// Create
				PortalService.store(this.transformedData()).then(response => {
					this.fetch();
					this.$buefy.toast.open({
						message: "Portal Created",
						type: "is-success",
						position: "is-top-right"
			        });
			        this.createCodeModal = false;
				})
			}
		},
		generateFormData() {
			this.form.subdomain = this.selectedRow ? this.selectedRow.subdomain : '';
			this.form.long_name = this.selectedRow ? this.selectedRow.long_name : '';
			this.form.short_name = this.selectedRow ? this.selectedRow.short_name : '';
			this.form.color = this.selectedRow ? this.selectedRow.color : '';
			this.form.b_or_w = this.selectedRow ? this.selectedRow.b_or_w : '';
			this.logo_path = this.selectedRow && this.selectedRow.logo ? this.selectedRow.logo.path : '';
			this.form.logo = null;
		},
		toggleArchived(row) {
			PortalService.update(row.id, {toggleArchive: true}).then(response => {
				this.fetch();
				this.$buefy.toast.open({
					message: "Portal Updated",
					type: "is-success",
					position: "is-top-right"
		        });
			})
		},
		transformedData() {
			let formData = new FormData(this.$refs.form);
			formData.append("file", this.form.logo);
			formData.append("subdomain", this.form.subdomain);
			formData.append("long_name", this.form.long_name);
			formData.append("short_name", this.form.short_name);
			formData.append("color", this.form.color);
			formData.append("b_or_w", this.form.b_or_w);
			return formData;
	    },
	},
	mounted() {
		this.fetch();
	}
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Portals/partials/table.vue